import Vue from 'vue'
// import Vuex from 'vuex'
import Router from 'vue-router'


const Home = () => import('../views/Home')

Vue.use(Router)
//防止跳转相同路由报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

export default new Router({
  routes: [{
      path: '/home',
      name: 'home',
      component: Home
    },
   
  ]
})
